module.exports = __webpack_public_path__ + "img/1527895327.40213c8d.jpg";